export default function CMemoryAddress() {
  return <h2>C Memory Address</h2>;
}
